import { Controller } from '@hotwired/stimulus';

// Recherche d'une liste : le formulaire, hors de la Frame
// des lignes, part 300 ms après la dernière frappe ; l'adresse de la page
// est remplacée par celle de la recherche (history.replaceState, sans visite
// Turbo : un clic juste après la recherche n'est pas perdu).
export default class extends Controller {
    queue() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.submit(), 300);
    }

    submit() {
        this.element.requestSubmit();
        const url = new URL(this.element.action, window.location.href);
        new FormData(this.element).forEach((value, name) => {
            if (value !== '') url.searchParams.set(name, value);
        });
        window.history.replaceState(window.history.state, '', url.pathname + url.search);
    }

    disconnect() {
        clearTimeout(this.timer);
    }
}
